import { useCallback, useEffect, useState } from "react";
import { UsersRound } from "lucide-react";
import PageHeader from "../components/PageHeader";
import StudentTable from "../components/StudentTable";
import { listWithdrawnStudents, updateWithdrawnStudent, deleteWithdrawnStudent } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

const columns = [
  { key: "name", header: "اسم الطالب" },
  { key: "national_id", header: "رقم الهوية" },
  { key: "stage", header: "المرحلة" },
  { key: "grade", header: "الصف" },
  { key: "section", header: "الفصل" },
  { key: "academic_year", header: "العام الدراسي" },
  { key: "withdrawal_date", header: "تاريخ الانسحاب" },
];

export default function WithdrawnStudentsList() {
  const { currentStage } = useAuth();
  const [rows, setRows] = useState([]);
  const reload = useCallback(async () => {
    const params = currentStage && currentStage !== "all" ? { stage: currentStage } : {};
    setRows(await listWithdrawnStudents(params));
  }, [currentStage]);
  useEffect(() => { reload(); }, [reload]);
  return (
    <div>
      <PageHeader title="عرض الطلاب المنسحبين" subtitle="بحث وتصفية وتعديل سجلات الطلاب المنسحبين" icon={UsersRound} />
      <StudentTable
        title="تقرير الطلاب المنسحبين"
        rows={rows} columns={columns}
        dateKey="withdrawal_date" dateLabel="تاريخ الانسحاب"
        apiUpdate={updateWithdrawnStudent} apiDelete={deleteWithdrawnStudent}
        reload={reload} testidPrefix="withdrawn-list" accent="rose"
      />
    </div>
  );
}
